import React from 'react'
import styled from 'styled-components'

const FooterWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #5b6680;
  font-size: 13px;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`

const Accent = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4d60c2;
  font-weight: 600;
`

const AdminAnnouncementFooter = ({ data }) => {
	const total = data?.count ?? 0

	return (
		<FooterWrapper>
			<span>
				총 <Accent>{total}</Accent>개의 공지를 관리 중입니다.
			</span>
			<span>페이지당 5개씩 노출됩니다.</span>
		</FooterWrapper>
	)
}

export default AdminAnnouncementFooter

